document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".mega-menu").forEach(details => {
    const summary = details.querySelector("summary");

    details.addEventListener("mouseenter", () => {
      summary.setAttribute("aria-expanded", "true");
      details.setAttribute("open", "true");
    });

    details.addEventListener("mouseleave", () => {
      summary.setAttribute("aria-expanded", "false");
      details.removeAttribute("open");
    });
  });

  const button = document.querySelector('#cart-icon-bubble')
  if(button){
    button.addEventListener('click', ()=>{
      const popup = document.querySelector('#cart-notification')
      if(popup){
        popup.classList.add('animate', 'active')
      }
    })
  }
  const arrayIdForms = [341732,359111]

  arrayIdForms.forEach(id => {
    const formContainer = document.querySelector(`div[data-forms-id="forms-root-${id}"]`)
    const config = { attributes: true, childList: true, subtree: true };

    if(!formContainer) return;
    const callback = (mutationList, observer) => {
      const formRegister = formContainer.querySelector('form-embed')
      if(!formRegister) return;
      const shadowRoot = formRegister.shadowRoot;
      if(!shadowRoot)return; 
      const style = document.createElement('style');
      style.textContent = `
      form fieldset legend{
        display:none;
      }
    `
      shadowRoot.appendChild(style);
      observer.disconnect();
    };

    const observer = new MutationObserver(callback);
    observer.observe(formContainer, config); 
  })
   
});
